import DemoEddmConfig, { DemoEddmOptionId, DemoEddmQuantity } from '~/tenants/demo/performable/eddm/DemoEddmConfig';
import DemoJob from '~/tenants/demo/model/DemoJob';
import { TenantOrderLine } from '~/lib/model';
import { Big } from 'big.js';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import { DemoOrderType } from '~/tenants/demo/model/DemoOrder';

interface DemoEddmOptions {
  revenue: Record<DemoEddmQuantity, number>;
  height: number;
  width: number;
}

export const DEMO_EDDM_OPTIONS: Record<DemoEddmOptionId, DemoEddmOptions> = {
  [DemoEddmOptionId.NINE]: {
    revenue: {
      [DemoEddmQuantity.QTY_250]: 150,
      [DemoEddmQuantity.QTY_500]: 225,
      [DemoEddmQuantity.QTY_1000]: 400,
      [DemoEddmQuantity.QTY_2500]: 875,
    },
    width: 6.25,
    height: 9,
  },
  [DemoEddmOptionId.TWELVE]: {
    revenue: {
      [DemoEddmQuantity.QTY_250]: 165,
      [DemoEddmQuantity.QTY_500]: 250,
      [DemoEddmQuantity.QTY_1000]: 450,
      [DemoEddmQuantity.QTY_2500]: 950,
    },
    width: 6.25,
    height: 12,
  },
};

export default class DemoEddmJob extends DemoJob<typeof DemoEddmConfig> {
  get performable() {
    return DemoEddmConfig;
  }

  get eligible() {
    return this.order.metadata.type !== DemoOrderType.COMMERCIAL;
  }

  defaultValue(): ZodVersionedMetadata<(typeof DemoEddmConfig)['schema']> {
    return {
      option: DemoEddmOptionId.NINE,
      version: schema_latest_version(DemoEddmConfig.schema),
      postage: false,
      quantity: DemoEddmQuantity.QTY_250,
    };
  }

  revenueLines(): TenantOrderLine[] {
    const amount = new Big(DEMO_EDDM_OPTIONS[this.metadata.option].revenue[this.metadata.quantity]);

    const lines: TenantOrderLine[] = [
      {
        amount,
        description: this.performable.name,
        id: this.performable.id,
      },
    ];

    if (this.metadata.postage) {
      lines.push({
        amount: new Big(this.metadata.quantity).times('0.20'),
        description: 'Postage',
        id: 'postage',
      });
    }

    return lines;
  }
}
